import {CollectionModel} from '../types';
import {useGet} from './../useHttpHooks';

const useGetUserCollections = () =>
    useGet<CollectionModel[]>(`/api/collections/get-user-collections`, {
        errorMessage: 'GET api/collections/get-user-collections failed'
    });

export default useGetUserCollections;
